import { render, staticRenderFns } from "./SectorsDash.vue?vue&type=template&id=3eae1089&"
import script from "./SectorsDash.vue?vue&type=script&lang=js&"
export * from "./SectorsDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports